export enum MapColors {
  LightOcean = '#E6EDFA',
  DarkOcean = '#20232E',
  LightLand = '#CAD5EA',
  DarkLand = '#262A36',
}
